// @ vendors
const React = require('react');
const PropTypes = require('prop-types');

const InsuranceRequestWizardBenefits = ({ icon, title, description }) => {
    return (
        <div className="col-xs-6 home-insurance-step-product__benefits">
            <i className={`home-insurance-step-product__beneftis-icon ${icon}`} />
            <div className="home-insurance-step-product__benefits__title">
                {title}
            </div>
            <div className="ok-box-title__separator home-insurance-step-product__benefits-separator"></div>
            <div className="col-xs-10 home-insurance-step-product__benefits__subtitle">
                {description}
            </div>
        </div>
    );
};

InsuranceRequestWizardBenefits.propTypes = {
    icon: PropTypes.string.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
};

module.exports = InsuranceRequestWizardBenefits;
